export const track = (event, data) => {
  if (window.analytics === undefined) {
    return
  }
  window.analytics.track(event, {
    ...data,
  })
}

export const page = () => {}

export const identify = (userId, data = {}) => {
  if (window.analytics === undefined) {
    return
  }

  window.analytics.identify(userId, { ...data })
}
